<template>
  <el-dialog title="批量设置等级" :visible.sync="dialogVisible" width="25%">
    <div v-if="loading" class="loading-wrapper">
      <el-icon class="is-loading"><loading /></el-icon>
      加载中...
    </div>
    <div v-else class="level-selection">
      等级：
      <el-select
        v-model="selectedLevel"
        placeholder="请选择等级"
        clearable
        style="width: 40%"
      >
        <el-option
          v-for="level in levelOptions"
          :key="level.value"
          :label="level.label"
          :value="level.value"
        />
      </el-select>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSave">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { submit } from "@/api/base";
export default {
  data() {
    return {
      dialogVisible: false, // 控制对话框显示
      levelOptions: [], // 等级选项
      selectedLevel: null, // 选中的等级
      loading: false, // 等级加载状态
      selectRows: [], // 选中的行数据
    };
  },
  methods: {
    async open(rows) {
      this.dialogVisible = true; // 关键：显示对话框
      this.loading = true;
      this.selectRows = rows;
      try {
        const res = await submit(
          "/api/common/getCustomerParameter?key=PurchaserLevels"
        );
        if (res.success && res.data) {
          const levelsData = JSON.parse(res.data);
          this.levelOptions = Object.keys(levelsData).map((key) => ({
            value: key,
            label: levelsData[key] || key,
          }));
        }
      } catch (error) {
        console.error("加载等级失败:", error);
        this.$message.error("加载等级失败");
      } finally {
        this.loading = false;
      }
    },
    async handleSave() {
      const selectedIds = this.selectRows.map((row) => row.ID);
      const selectedLevelOption = this.levelOptions.find(
        (option) => option.value === this.selectedLevel
      );
      const levelName = selectedLevelOption
        ? selectedLevelOption.label
        : this.selectedLevel;
      this.$emit("handleBatchSaveLevels", {
        ids: selectedIds.join(","),
        levelCode: this.selectedLevel,
        levelName: levelName,
      });
      this.dialogVisible = false;
    },
  },
};
</script>
